import { useEffect, useRef, useContext } from 'react';
import { RideEventsContext } from '../context/RideEventsContext';

export function useVehicleEvents(onLocation, onOffline) {
  const ctx = useContext(RideEventsContext);
  const onLocationRef = useRef(onLocation);
  const onOfflineRef = useRef(onOffline);
  useEffect(() => { onLocationRef.current = onLocation; });
  useEffect(() => { onOfflineRef.current = onOffline; });

  useEffect(() => {
    if (!ctx) return undefined;
    const unsubLocation = ctx.subscribeVehicleLocation((data) => onLocationRef.current?.(data));
    const unsubOffline = ctx.subscribeVehicleOffline((data) => onOfflineRef.current?.(data));
    return () => {
      unsubLocation();
      unsubOffline();
    };
  }, [ctx]);
}
